__webpack_public_path__ = `${process.env.API_SERVER}/build/`

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import OauthComponent from './js/oauth.js'

window.OauthComponent = OauthComponent

import './styles/widget/overflow.css'

import '@fontsource/dm-sans/400.css'
import '@fontsource/dm-sans/500.css'
import '@fontsource/dm-sans/700.css'

import { parse as yamlParse } from "yaml"

import WidgetRouter from "./features/widget/router/Router"

const root = document.getElementById('_oa_widget_root')
window.document.widgetRoot = root

const api_key = document.currentScript.dataset.apiKey
    ? document.currentScript.dataset.apiKey
    : root?.dataset.apiKey ?? ''

const url = new URL(
    `${process.env.WIDGET_API_CONFIG_URL}/${api_key ?? ''}/public/yaml`,
    `https://${process.env.WIDGET_API_DOMAIN}`
)

// const url = new URL(
//     `/api/widget/config/${api_key ?? ''}`, // /public/yaml`,
//     `https://beheerapp.mizar-it.com`
// )

url.searchParams.set('t', Date.now())
url.searchParams.set('format', 'yaml')

let mode = 'default',
    buttonOnMobile = "false";

if (document.currentScript.dataset.apiKey) {
    url.searchParams.set('wid', document.currentScript.dataset.widgetId ?? '')
    mode = document.currentScript.dataset.mode || 'default'
    buttonOnMobile = document.currentScript.dataset.buttonOnMobile;
}
else if (root) {
    url.searchParams.set('wid', root.dataset.widgetId ?? '')
    mode = root.dataset.mode || 'default'
    buttonOnMobile = root.dataset.buttonOnMobile;
}

function initWidget(yaml) {
    const config = yamlParse(yaml)

    // DEBUG purposes
    config.settings.skin = 'default'
    // // config.settings.skin = 'demo-skin'
    // config.settings.allowMultipleAppointments = true
    // config.settings.sameMultipleAppointments = false

    //Include the mode from the separate attribute, because it is not in the config
    config.settings.widgetMode = mode;
    if (config.settings.defaultOpened) {
        config.settings.defaultOpened.mobile = !(buttonOnMobile == "true")
    }
    // debug, for checkout widget
    // config.settings.orientation = "horizontal"
    config.flow.views[config.flow.views.length - 1].requirements = []
    if (config.settings.widgetMode !== 'standalone') {
        const inFrame = typeof window !== 'undefined' && window.self !== window.top
        // const isDesktop = inFrame ? window.screen.width > 500 : window.innerWidth > 500

        /// the non-standalone widgets are always in an iframe
        const isDesktop = window.screen.width > 500

        if (!inFrame) {
            // get the margin already applied by the website
            let negativeWidth = 0,
                requiredMargin = 20
            if (document.getElementById('_oa_widget_root').offsetWidth > 100) { // this is somewhat arbitrary, but I want to avoid cases where this is somehow 0
                let websiteMargin = window.screen.width - document.getElementById('_oa_widget_root').offsetWidth
                requiredMargin = (40 - websiteMargin) / 2 // we want 2x 20px margin
                if (requiredMargin < 0) {
                    // the website already added more than 40px margin, so we actually need to make the widget even smaller
                    negativeWidth = websiteMargin - 40
                    requiredMargin = 0
                }
            }
            else {
                // use fallback, couldn't determine available width for the widget
            }

            function receiveMessage(event) {

                const origin = event.origin || ''

                let parts1 = origin.split('.')
                parts1.shift()

                let parts2 = `${process.env.API_SERVER}`.split('.')
                parts2.shift()

                if (parts1.join('.') !== parts2.join('.')) return

                if (event.data.type === 'setDimensions') {
                    const widgetFrame = document.getElementById(`_oa_widget_frame_${url.searchParams.get('widget_id')}`)
                    widgetFrame.style.height = `${event.data.height}`
                    widgetFrame.style.width = `${event.data.width}`
                    if (event.data.bottom) {
                        widgetFrame.style.bottom = event.data.bottom
                    }
                    if (event.data.left) {
                        widgetFrame.style.left = event.data.left
                    }
                    if (event.data.right) {
                        widgetFrame.style.right = event.data.right
                    }
                    if (event.data.top) {
                        widgetFrame.style.top = event.data.top
                    }
                    if (event.data.position) {
                        widgetFrame.style.position = event.data.position
                    }
                }
                if (event.data.type === 'redirect') {
                    window.location.href = event.data.url
                }
            }

            window.addEventListener('message', receiveMessage, false)

            let scripts = document.getElementsByTagName("script"),
                a = Array.prototype.slice.call(scripts)

            let thisScript = a.find((script) => {
                if (script.src) {
                    let u = URL.parse(script.src)
                    return u.pathname === '/build/widget/widget.js'

                }
                return false
            })

            let origin = URL.parse(thisScript.src)

            const root = document.getElementById('_oa_widget_root')
            let iframe = document.createElement('iframe')
            iframe.id = `_oa_widget_frame_${url.searchParams.get('widget_id')}`
            iframe.src = `${origin.origin}/book/${config.settings.api_key}/${config.settings.widget_id}/${mode}/${buttonOnMobile}${window.location.hash}`

            let style = {
                backgroundColor: 'transparent',
                border: 'none',
                width: isDesktop
                    ? config.settings.orientation === "horizontal" ? "100%" : "520px"
                    : (config.settings.widgetMode === 'default' && config.settings.defaultOpened.mobile ? `calc(100dvw - ${negativeWidth + 40}px)` : '100dvw'),
                height: isDesktop || (config.settings.widgetMode === 'default' && config.settings.defaultOpened.mobile) ? '80dvh' : '100dvh',
                ...(config.settings.widgetMode === 'default' && config.settings.defaultOpened.mobile && !isDesktop && {
                    margin: `0 ${requiredMargin}px`
                }),
                ...(isDesktop || (config.settings.widgetMode === 'default' && config.settings.defaultOpened.mobile)) && {
                    maxHeight: '1200px'
                }

                // maxHeight: isDesktop || config.settings.widgetMode === 'default' ? '80dvh' : '100dvh'
            }

            if (['triggerButtonLeft', 'triggerButtonRight'].includes(config.settings.widgetMode)) {
                Object.assign(style, {
                    position: 'fixed',
                    bottom: isDesktop ? '32px' : '10px',
                    height: '54px',
                    // on desktop, set it initially too large, the WidgetWrapper will correct the width after the first actual render
                    width: '400px', //isDesktop ? '400px' : '100dvw',
                    zIndex: 65537
                })
                if (config.settings.widgetMode === 'triggerButtonLeft') {
                    style.left = isDesktop ? '32px' : '10px'
                }
                if (config.settings.widgetMode === 'triggerButtonRight') {
                    style.right = isDesktop ? '32px' : '10px'
                }
            }
            else {
                // default
                if (!isDesktop && !config.settings.defaultOpened.mobile) {
                    // button on mobile to open full screen widget
                    Object.assign(style, {
                        height: '54px',
                        width: '400px',
                        maxHeight: '100dvh',
                        zIndex: 65537
                    })
                }
            }
            Object.assign(iframe.style, style)
            root.appendChild(iframe)
        }
        else {
            const root = createRoot(document.getElementById('_oa_widget_root'))
            window.document.widgetRoot = root
            root.render(
                <StrictMode>
                    <WidgetRouter config={config} mode={mode} />
                </StrictMode>
            )
        }
    }
    else {
        // standalone
        const root = createRoot(document.getElementById('_oa_widget_root'))
        window.document.widgetRoot = root
        root.render(
            <StrictMode>
                <WidgetRouter config={config} mode={mode} />
            </StrictMode>
        )
    }
    window.document.removeWidget = () => {
        if (window.document.widgetRoot) {
            window.document.widgetRoot.unmount()
            let div_root = document.getElementById('_oa_widget_root')
            if (div_root) {
                div_root.innerHTML = ''
            }
        }
    }
}

window.document.initWidget = initWidget

fetch(url, {
    method: "GET"
})
    .then((response) => response.text())
    .then((yaml) => {
        if (yaml !== 'Could not find the widget configuration') {
            initWidget(yaml)
        }
    })